import { Typography } from '@mui/material';
import { Popup } from '@vis.gl/react-maplibre';

import { PopupContent } from '@/components/PopupContent';
import { PopupDatePeriod } from '@/components/popup/PopupDatePeriod';
import { PopupTitle } from '@/components/popup/PopupTitle';
import type { TrafficInfoBoardFeature } from '@/types/TrafficInfoBoardFeature';

interface TrafficInfoBoardProps {
  feature?: TrafficInfoBoardFeature;
  onClose: () => void;
}

export function TrafficInfoBoardPopup({ feature, onClose }: TrafficInfoBoardProps) {
  if (!feature) {
    return null;
  }

  const [longitude, latitude] = feature.geometry.coordinates;

  const description = feature.properties.content?.replace('{}', '').replace('{"', '').replace('"}', '');

  return (
    <Popup
      key={feature.properties.id}
      closeButton={false}
      latitude={latitude}
      longitude={longitude}
      maxWidth="min(480px, 75vw)"
      offset={18}
      onClose={onClose}
    >
      <PopupContent onClose={onClose}>
        <PopupTitle>{feature.properties.id}</PopupTitle>
        <PopupDatePeriod feature={feature} />

        {description ? <Typography>{description}</Typography> : null}
      </PopupContent>
    </Popup>
  );
}
